<template>
  <v-dialog v-model="open" @click:outside="$emit('update:open', false)" max-width="700">
    <v-card class="">
      <v-card-text class="py-6 d-flex align-center justify-space-between">
        <div />
        <h1 class="text-center">Registro de Alterações</h1>
        <v-btn icon @click="close()" class="align-self-end">
          <v-icon> mdi-close </v-icon>
        </v-btn>
      </v-card-text>
      <v-card-text>
        <div v-html="markdownToHtml"></div>
        <div class="mt10"></div>
      </v-card-text>
      <v-card-actions class="d-flex justify-end pb-5">
        <v-btn class="px-6" color="error" large @click="close()"> Fechar </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import changeLog from '../assets/melhoriasVersao.md';
import marked from 'marked';
export default {
  name: 'ChangeLog',
  props: {
    open: {
      default: false,
      type: Boolean
    }
  },
  data: () => ({
    markdown: changeLog
  }),
  computed: {
    markdownToHtml() {
      return marked(this.markdown);
    }
  },
  methods: {
    close() {
      this.$emit('close');
    }
  }
  //   watch: {
  //     open(val) {},
  //   },
};
</script>

<style></style>
